import { useMutation, useQueryClient } from "@tanstack/react-query";
import { kpiService } from "../../../services/kpiService";

export const useDeleteKpi = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ kpiId }: { kpiId: string }) => {
      const deleted = await kpiService.delete(kpiId);
      if (!deleted) {
        throw new Error(`KPI with id "${kpiId}" not found`);
      }
      return { deleted, kpiId };
    },
    onSuccess: ({ kpiId }) => {
      qc.invalidateQueries({ queryKey: ["kpi", kpiId] });
      qc.invalidateQueries({ queryKey: ["kpis"] });
      qc.invalidateQueries({ queryKey: ["service-templates"] });
    },
  });
};
